import {chartPreviewActionTypes} from "./actionTypes";
export const setChartPreview=(payload)=> {    
    return {
      type: chartPreviewActionTypes.SET_CHART_PREVIEW, 
      payload     
    };
  }